import { useLoaderData, useNavigate, useParams } from "react-router-dom";
import { useState } from "react";
import TextInput from "../../components/Selectors/TextInput";
import IconButton from "../../components/IconButton";
import { MdArrowLeft as Prev } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { edit } from "../../reducers/dataSlice";
import { toast } from "react-toastify";
import SwitchButton from "../Selectors/SwitchButton";
import { putDataApi } from "../../axios/DataManagementApi";
import { PrimaryButton } from "../Buttons/Button";
import { capitalizeFirstLetter, isEmptyString } from "../../utils/common";
import { useTranslation } from "react-i18next";
import NumericInput from "../Inputs/NumericInput";

const ConfiguredSourceEdit = () => {
  const { t } = useTranslation(["common", "button", "toast"]);

  const dataloaded = useLoaderData();
  const dispatch = useDispatch();
  const observedSystemId = useSelector((state) => state.selected.observed_system);
  const redirect = "/";
  const [isLoading, setIsLoading] = useState(false);
  const { id } = useParams();
  const history = useNavigate();
  const [item, setItem] = useState(dataloaded);
  const onChange = (name, value) => {
    setItem((prevState) => {
      return { ...prevState, [name]: value };
    });
  };

  return (
    <div className="m-8  rounded-lg bg-white px-8 pb-8  pt-4 shadow-lg">
      <div className="flex gap-x-1.5">
        <IconButton bg={true} Icon={<Prev size={40} />} value={""} callback={() => history(redirect)} />
        <h2 className="text-3xl font-semibold text-blue-900">{capitalizeFirstLetter(t("configured_source"))}</h2>
      </div>
      <div className={"grid grid-cols-2 gap-4  border-b pb-2 lg:grid-cols-3"}>
        <TextInput required={true} name={"description"} value={item?.description} onChange={onChange} label={capitalizeFirstLetter(t("description"))} />
        <NumericInput
          required={true}
          name={"alert_delay"}
          value={item?.alert_delay}
          onChange={(name, value) => onChange(name, parseInt(value))}
          label={capitalizeFirstLetter(t("alert_delay"))}
          type={"number"}
        />
        <div className={"py-8"}>
          <SwitchButton onChange={() => onChange("is_active", !item?.is_active)} label={capitalizeFirstLetter(t("state"))} value={item?.is_active} />
        </div>
      </div>
      <div className={"flex justify-end gap-2 pt-2 "}>
        <PrimaryButton
          isLoading={isLoading}
          disabled={isLoading || isEmptyString(item.description) || isEmptyString(item.alert_delay)}
          label={t("edit", { ns: "button" })}
          callback={() => {
            setIsLoading(true);
            putDataApi("configured_source?observed_system_id=" + observedSystemId + "&configured_source_id=" + id, {
              description: item.description,
              alert_delay: item.alert_delay,
              is_active: item.is_active,
            })
              .then((res) => {
                console.debug(res);
                dispatch(edit({ type: "configured_source", updates: item, id: id }));
                setIsLoading(false);
                toast.success(t("CONFIGURED_SOURCE_EDIT", { ns: "toast" }));
                history(redirect);
              })
              .catch((error) => {
                console.debug(error);
                setIsLoading(false);
              });
          }}
        />
      </div>
    </div>
  );
};
export default ConfiguredSourceEdit;
